export default __webpack_public_path__ + "static/media/trilogo.0cfe6b9c.svg";